/**
 * Search results page: URL normalize, load more, progress.
 */
(function () {
  if (!document.querySelector('.search-page')) return;

  const SearchPage = {
    init() {
      if (this.normalizeUrl()) return;

      this.syncProgress();
      document.addEventListener('click', (event) => this.onLoadMoreClick(event));
    },

    normalizeUrl() {
      const params = new URLSearchParams(window.location.search);
      const q = params.get('q');
      if (!q?.trim()) return false;

      const hasBroken =
        params.has('options[unavailable_products]') ||
        params.has('options[fields]') ||
        /^title:/i.test(q);

      if (hasBroken) {
        const clean = new URLSearchParams();
        const normalized = q.replace(/^title:/i, '').trim();
        if (!normalized) return false;

        clean.set('q', normalized);
        clean.set('type', 'product');
        if (params.get('sort_by')) clean.set('sort_by', params.get('sort_by'));
        window.location.replace(`${window.location.pathname}?${clean.toString()}`);
        return true;
      }

      if (params.get('type') !== 'product') {
        params.set('type', 'product');
        window.location.replace(`${window.location.pathname}?${params.toString()}`);
        return true;
      }

      return false;
    },

    getGrid() {
      return document.querySelector('#SearchPageResults .search-page__grid');
    },

    syncProgress() {
      const footer = document.querySelector('[data-search-pagination]');
      const grid = this.getGrid();
      if (!footer || !grid) return;

      const shown = grid.querySelectorAll('li').length;
      const hasMore = Boolean(footer.dataset.nextUrl?.trim());
      const liquidTotal = parseInt(footer.dataset.total || '0', 10);
      const total = hasMore ? Math.max(liquidTotal, shown) : shown;

      this.updateProgress(footer, shown, total);
      footer.dataset.total = String(total);
      footer.dataset.shown = String(shown);
      this.updateItemCounts(total);

      if (!hasMore) {
        footer.querySelector('[data-search-load-more]')?.remove();
      }
    },

    updateItemCounts(total) {
      const template = document.querySelector('.search-page')?.dataset.countTemplate;
      if (!template) return;

      const text = template.replace('__COUNT__', String(total));
      document.querySelectorAll('[data-search-count]').forEach((el) => {
        el.textContent = text;
      });
    },

    updateProgress(footer, shown, total) {
      const progress = footer.querySelector('[data-search-progress]');
      if (!progress?.dataset.template) return;

      progress.textContent = progress.dataset.template
        .replace('__SHOWN__', String(shown))
        .replace('__TOTAL__', String(total));
    },

    onLoadMoreClick(event) {
      const button = event.target.closest('[data-search-load-more]');
      if (!button || button.disabled) return;

      const footer = button.closest('[data-search-pagination]');
      const sectionId = footer?.dataset.sectionId;
      const nextUrl = footer?.dataset.nextUrl;
      if (!sectionId || !nextUrl) return;

      const grid = this.getGrid();
      const results = document.getElementById('SearchPageResults');
      if (!grid) return;

      button.disabled = true;
      results?.classList.add('is-loading');

      const url = new URL(nextUrl, window.location.origin);
      url.searchParams.set('section_id', sectionId);

      fetch(url.toString())
        .then((response) => response.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('#SearchPageResults .search-page__grid > li').forEach((item) => {
            grid.appendChild(item);
          });

          const newFooter = doc.querySelector('[data-search-pagination]');
          footer.dataset.nextUrl = newFooter?.dataset.nextUrl || '';
          if (newFooter?.dataset.total) footer.dataset.total = newFooter.dataset.total;

          this.syncProgress();

          if (footer.dataset.nextUrl?.trim()) {
            button.disabled = false;
          }
        })
        .catch(() => {
          button.disabled = false;
        })
        .finally(() => {
          results?.classList.remove('is-loading');
        });
    },
  };

  window.SearchPage = SearchPage;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => SearchPage.init());
  } else {
    SearchPage.init();
  }
})();
